// Track Order JavaScript - Final Version
(function() {
  'use strict';

  const CONFIG = {
    apiEndpoint: 'https://tracking.markenda.space/',
    novaPoshtaApiUrl: 'https://api.novaposhta.ua/v2.0/json/',
    novaPoshtaApiKey: '027cc791d12e138a41bb38b5ebe9f836'
  };

  // Словарь перевода украинских городов
  const CITY_TRANSLATIONS = {
    'Одеса': 'Odesa',
    'Київ': 'Kyiv',
    'Харків': 'Kharkiv',
    'Дніпро': 'Dnipro',
    'Львів': 'Lviv',
    'Запоріжжя': 'Zaporizhzhia',
    'Кривий Ріг': 'Kryvyi Rih',
    'Миколаїв': 'Mykolaiv',
    'Маріуполь': 'Mariupol',
    'Вінниця': 'Vinnytsia',
    'Херсон': 'Kherson',
    'Полтава': 'Poltava',
    'Чернігів': 'Chernihiv',
    'Черкаси': 'Cherkasy',
    'Суми': 'Sumy',
    'Житомир': 'Zhytomyr',
    'Хмельницький': 'Khmelnytskyi',
    'Рівне': 'Rivne',
    'Тернопіль': 'Ternopil',
    'Івано-Франківськ': 'Ivano-Frankivsk',
    'Луцьк': 'Lutsk',
    'Ужгород': 'Uzhhorod',
    'Чернівці': 'Chernivtsi'
  };

  // Улучшенная функция перевода статусов
  const translateStatus = (text) => {
    if (!text) return text;
    
    const translations = {
      // Основные статусы
      'Відправлення прямує до': 'Shipment is on the way to',
      'Відправлення': 'Shipment',
      'Відправлено': 'Shipped',
      'Прибув в місто': 'Arrived in city',
      'Прибуло в місто': 'Arrived in city',
      'Очікує': 'Awaiting',
      'Доставлено': 'Delivered',
      'Одержано': 'Received',
      'Отримано': 'Received',
      'Створено': 'Created',
      'Передано': 'Transferred',
      'Передано до': 'Transferred to',
      'У дорозі': 'In transit',
      'На шляху': 'On the way',
      'Готово до видачі': 'Ready for pickup',
      'Готове до видачі': 'Ready for pickup',
      'Очікує на видачу': 'Awaiting pickup',
      'Видано одержувачу': 'Delivered to recipient',
      'Зберігається': 'In storage',
      'Повернуто': 'Returned',
      'Скасовано': 'Cancelled',
      
      // Дополнительные слова
      'до': 'to',
      'в': 'in',
      'на': 'at',
      'з': 'from',
      'від': 'from',
      'відділення': 'branch',
      'склад': 'warehouse'
    };
    
    let translated = text;
    
    // Заменяем все найденные украинские слова на английские
    for (let [ua, en] of Object.entries(translations)) {
      const regex = new RegExp(ua, 'gi');
      translated = translated.replace(regex, en);
    }
    
    return translated;
  };

  // Функция перевода города
  function translateCity(city) {
    if (!city) return '';
    return CITY_TRANSLATIONS[city] || city;
  }

  // Функция проверки авторизации
  function isCustomerLoggedIn() {
    return document.body.classList.contains('customer-logged-in') || 
           window.ShopifyAnalytics?.meta?.page?.customerId;
  }

  // Функция маскирования имени
  function maskName(fullName) {
    if (!fullName) return '';
    
    const parts = fullName.trim().split(' ');
    
    return parts.map(part => {
      if (part.length <= 2) return part;
      const first = part[0];
      const last = part[part.length - 1];
      const middle = '*'.repeat(part.length - 2);
      return first + middle + last;
    }).join(' ');
  }

  // Функция маскирования адреса
  function maskAddress(address) {
    if (!address) return '';
    
    const parts = address.split(';').map(p => p.trim()).filter(p => p);
    
    if (parts.length === 0) return '***';
    
    const city = parts[0];
    const street = parts[1] || '';
    
    if (street) {
      const streetWords = street.split(' ');
      const maskedStreet = streetWords.map(word => {
        if (word.length <= 3) return word;
        return word[0] + '*'.repeat(word.length - 2) + word[word.length - 1];
      }).join(' ');
      
      return city + ', ' + maskedStreet + '...';
    }
    
    return city;
  }

  const tabButtons = document.querySelectorAll('.track-tab');
  const formWrappers = document.querySelectorAll('.track-form-wrapper');
  const orderForm = document.getElementById('orderNumberForm');
  const trackingForm = document.getElementById('trackingNumberForm');
  const resultsContainer = document.getElementById('trackResults');

  function init() {
    setupTabs();
    setupForms();
    autoSearchFromUrl();
  }

  // Автопошук за параметром у посиланні (лист Shopify «Track My Order»):
  //   /pages/track-order?tracking_number=59500007689857  -> вкладка Tracking Number
  //   /pages/track-order?order_number=1234 (або %231234)   -> вкладка Order Number
  // Ручний пошук не змінюється: без параметрів сторінка працює як раніше.
  function readParam(names) {
    let params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return ''; }
    for (const n of names) {
      const v = params.get(n);
      if (v && v.trim()) return v.trim();
    }
    return '';
  }

  function submitForm(form) {
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  }

  function autoSearchFromUrl() {
    // лише цифри / латиниця / дефіс — у поле і в запит не потрапляє нічого зайвого
    const tracking = readParam(['tracking_number', 'tracking', 'ttn'])
      .replace(/\s+/g, '').replace(/[^A-Za-z0-9-]/g, '').slice(0, 40);
    const order = readParam(['order_number', 'order'])
      .replace(/\s+/g, '').replace(/[^A-Za-z0-9#-]/g, '').slice(0, 30);

    if (tracking && trackingForm) {
      const tab = document.querySelector('.track-tab[data-tab="tracking"]');
      if (tab && !tab.classList.contains('active')) tab.click();
      const input = document.getElementById('trackingNumber');
      if (input) input.value = tracking;
      submitForm(trackingForm);
      return;
    }

    if (order && orderForm) {
      const tab = document.querySelector('.track-tab[data-tab="order"]');
      if (tab && !tab.classList.contains('active')) tab.click();
      const input = document.getElementById('orderNumber');
      if (input) input.value = order;
      submitForm(orderForm);
    }
  }

  function setupTabs() {
    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        const tabType = button.dataset.tab;
        
        tabButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
        
        formWrappers.forEach(wrapper => {
          wrapper.classList.remove('active');
          if (wrapper.id === `${tabType}-form`) {
            wrapper.classList.add('active');
          }
        });
        
        resultsContainer.classList.remove('show');
        resultsContainer.innerHTML = '';
      });
    });
  }

  function setupForms() {
    if (orderForm) {
      orderForm.addEventListener('submit', handleOrderSearch);
    }
    
    if (trackingForm) {
      trackingForm.addEventListener('submit', handleTrackingSearch);
    }
  }

  async function handleOrderSearch(e) {
    e.preventDefault();
    
    const submitButton = e.target.querySelector('.track-button');
    const orderNumber = document.getElementById('orderNumber').value.trim();
    
    if (!orderNumber) return;
    
    setLoadingState(submitButton, true);
    
    try {
      const response = await fetch(CONFIG.apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          action: 'getOrder',
          orderNumber: orderNumber
        })
      });

      const data = await response.json();
      
      if (!data.success || !data.order) {
        showError('Order Not Found', 'We couldn\'t find an order with this number. Please check and try again.');
        return;
      }

      const orderData = data.order;
      const trackingNumber = orderData.tracking_number;
      const trackingInfo = orderData.tracking_info;
      
      if (!trackingNumber || trackingNumber === '') {
        showPreparing(orderData.name || orderNumber);
        return;
      }

      if (trackingInfo) {
        displayTrackingResults(orderData, trackingInfo);
      } else {
        showPreparing(orderData.name || orderNumber, trackingNumber);
      }
      
    } catch (error) {
      console.error('Order search error:', error);
      showError('Error', 'Something went wrong. Please try again later.');
    } finally {
      setLoadingState(submitButton, false);
    }
  }

  async function handleTrackingSearch(e) {
    e.preventDefault();
    
    const submitButton = e.target.querySelector('.track-button');
    const trackingNumber = document.getElementById('trackingNumber').value.trim();
    
    if (!trackingNumber) return;
    
    setLoadingState(submitButton, true);
    
    try {
      const trackingInfo = await getNovaPoshtaTracking(trackingNumber);
      
      if (trackingInfo) {
        displayTrackingResults(null, trackingInfo, trackingNumber);
      } else {
        showError('Tracking Number Not Found', 'This tracking number doesn\'t exist. Please check your account dashboard.');
      }
      
    } catch (error) {
      console.error('Tracking search error:', error);
      showError('Error', 'Something went wrong. Please try again later.');
    } finally {
      setLoadingState(submitButton, false);
    }
  }

  async function getNovaPoshtaTracking(trackingNumber) {
    try {
      const requestBody = {
        apiKey: CONFIG.novaPoshtaApiKey,
        modelName: 'TrackingDocument',
        calledMethod: 'getStatusDocuments',
        methodProperties: {
          Documents: [
            {
              DocumentNumber: trackingNumber,
              Phone: ''
            }
          ]
        }
      };
      
      const response = await fetch(CONFIG.novaPoshtaApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      
      const data = await response.json();
      
      if (data.success && data.data && data.data.length > 0) {
        return data.data[0];
      }
      
      return null;
    } catch (error) {
      console.error('Nova Poshta API error:', error);
      return null;
    }
  }

  function displayTrackingResults(orderData, trackingInfo, trackingNumber = null) {
    const orderNum = orderData ? (orderData.name || `#${orderData.number}`) : 'N/A';
    const trackNum = trackingInfo.Number || trackingNumber;
    
    const isLoggedIn = isCustomerLoggedIn();
    
    const statusCode = trackingInfo.StatusCode || '5';
    const statusText = trackingInfo.Status || 'Order is on the way';
    
    const translatedStatus = translateStatus(statusText);
    
    // Маппинг StatusCode к классам и текстам
    const statusMapping = {
      '1': { class: 'status-preparing', text: 'Order Created' },
      '2': { class: 'status-preparing', text: 'Removed' },
      '3': { class: 'status-shipped', text: 'Departed' },
      '4': { class: 'status-arrived', text: 'Arrived in Destination City' },
      '5': { class: 'status-shipped', text: 'In Transit' },
      '6': { class: 'status-ready', text: 'Ready for Pickup' },
      '7': { class: 'status-delivered', text: 'Delivered' },
      '8': { class: 'status-delivered', text: 'Delivered and Money Transferred' },
      '9': { class: 'status-preparing', text: 'Order Registered' },
      '10': { class: 'status-preparing', text: 'Being Prepared' },
      '11': { class: 'status-preparing', text: 'Pickup Scheduled' },
      '101': { class: 'status-preparing', text: 'Transferred to Sender' },
      '102': { class: 'status-preparing', text: 'Canceled' },
      '103': { class: 'status-shipped', text: 'In International Transit' },
      '104': { class: 'status-arrived', text: 'Customs Clearance' },
      '105': { class: 'status-ready', text: 'Ready for Pickup (Paid)' },
      '106': { class: 'status-delivered', text: 'Delivered Successfully' }
    };
    
    let statusClass = 'status-shipped';
    let statusDisplay = translatedStatus;
    
    if (statusMapping[statusCode]) {
      statusClass = statusMapping[statusCode].class;
      statusDisplay = translatedStatus.length > statusMapping[statusCode].text.length 
        ? translatedStatus 
        : statusMapping[statusCode].text;
    }
    
    const citySender = translateCity(trackingInfo.CitySender);
    const cityRecipient = translateCity(trackingInfo.CityRecipient);
    
    const countrySender = 'Ukraine';
    const countryRecipient = trackingInfo.InternationalDeliveryType === 'Export' ? 'United States' : 'Ukraine';
    
    const recipientName = isLoggedIn 
      ? trackingInfo.RecipientFullName 
      : maskName(trackingInfo.RecipientFullName);
    
    const recipientAddress = isLoggedIn 
      ? trackingInfo.RecipientAddress 
      : maskAddress(trackingInfo.RecipientAddress);
    
    const html = `
      <div class="result-card">
        <div class="result-header">
          <div class="result-order-info">
            <h2>Order ${orderNum}</h2>
            <div class="tracking-number">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="3" y1="9" x2="21" y2="9"></line>
                <path d="M9 21V9"></path>
              </svg>
              <span>Tracking: <strong>${trackNum}</strong></span>
            </div>
          </div>
          <span class="result-status-badge ${statusClass}">${statusDisplay}</span>
        </div>
        
        <div class="shipping-route">
          <div class="route-location">
            <div class="route-icon from">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"></circle>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </div>
            <div class="route-details">
              <span class="route-label">From</span>
              <span class="route-city">${citySender}</span>
              <span class="route-country">${countrySender}</span>
            </div>
          </div>
          
          <div class="route-line">
            <svg width="60" height="24" viewBox="0 0 60 24" fill="none">
              <line x1="0" y1="12" x2="55" y2="12" stroke="currentColor" stroke-width="2" stroke-dasharray="4 4"/>
              <polygon points="55,8 60,12 55,16" fill="currentColor"/>
            </svg>
          </div>
          
          <div class="route-location">
            <div class="route-icon to">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
            </div>
            <div class="route-details">
              <span class="route-label">To</span>
              <span class="route-city">${cityRecipient}</span>
              <span class="route-country">${countryRecipient}</span>
            </div>
          </div>
        </div>
        
        ${trackingInfo.ScheduledDeliveryDate && !['7', '106'].includes(statusCode) ? `
          <div class="delivery-estimate-box">
            <div class="estimate-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
            </div>
            <div class="estimate-content">
              <span class="estimate-label">Estimated Delivery</span>
              <span class="estimate-date">${formatDate(trackingInfo.ScheduledDeliveryDate)}</span>
            </div>
          </div>
        ` : ''}
        
        <div class="tracking-timeline">
          <h3 class="timeline-title">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
            </svg>
            Delivery Progress
          </h3>
          ${generateTimeline(trackingInfo)}
        </div>
        
        ${trackingInfo.RecipientFullName ? `
          <div class="recipient-info-box ${!isLoggedIn ? 'locked' : ''}">
            <div class="recipient-header">
              <h3>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                Recipient Information
              </h3>
              ${!isLoggedIn ? `
                <span class="locked-badge">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </svg>
                  Private
                </span>
              ` : ''}
            </div>
            
            <div class="recipient-details">
              <div class="info-row">
                <div class="info-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <div class="info-content">
                  <label>Name</label>
                  <span class="${!isLoggedIn ? 'masked-text' : ''}">${recipientName}</span>
                </div>
              </div>
              
              ${trackingInfo.RecipientAddress ? `
                <div class="info-row">
                  <div class="info-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                      <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                  </div>
                  <div class="info-content">
                    <label>Delivery Address</label>
                    <span class="${!isLoggedIn ? 'masked-text' : ''}">${recipientAddress}</span>
                  </div>
                </div>
              ` : ''}
            </div>
            
            ${!isLoggedIn ? `
              <div class="login-prompt-box">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
                <p>To view complete recipient details, please sign in to your account</p>
                <a href="/account/login" class="btn-signin">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                    <polyline points="10 17 15 12 10 7"></polyline>
                    <line x1="15" y1="12" x2="3" y2="12"></line>
                  </svg>
                  Sign In
                </a>
              </div>
            ` : ''}
          </div>
        ` : ''}
      </div>
    `;
    
    resultsContainer.innerHTML = html;
    resultsContainer.classList.add('show');
    
    setTimeout(() => {
      resultsContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 100);
  }

 function generateTimeline(trackingInfo) {
  const events = [];
  const statusCode = trackingInfo.StatusCode || '5';
  const status = trackingInfo.Status || '';
  const translatedStatus = translateStatus(status);
  
  // Проверяем статус доставки
  const isReceived = translatedStatus.toLowerCase().includes('received');
  const isDelivered = ['7', '106', '8'].includes(statusCode) || translatedStatus.toLowerCase().includes('delivered');

  events.push({
    title: 'Order Created',
    description: trackingInfo.DateCreated 
      ? `Created on ${formatDate(trackingInfo.DateCreated)}` 
      : 'Your order has been created',
    completed: true
  });

  if (trackingInfo.CitySender) {
    const citySender = translateCity(trackingInfo.CitySender);
    events.push({
      title: `Shipped from ${citySender}`,
      description: 'Package has been picked up',
      completed: true
    });
  }

  if (['5', '3', '103'].includes(statusCode) && !isDelivered && !isReceived) {
    events.push({
      title: 'In Transit',
      description: translatedStatus,
      completed: false,
      active: true
    });
  }

  if (['4', '104', '6', '105', '7', '106', '8'].includes(statusCode) || isDelivered || isReceived) {
    const cityRecipient = translateCity(trackingInfo.CityRecipient);
    events.push({
      title: `Arrived in ${cityRecipient}`,
      description: 'Package arrived at destination',
      completed: true
    });
  }

  if (['6', '105', '7', '106', '8'].includes(statusCode) || isDelivered || isReceived) {
    events.push({
      title: 'Ready for Pickup',
      description: 'Available for pickup',
      completed: true
    });
  }

  // ЕСЛИ RECEIVED - зеленый кружок
  if (isReceived) {
    const deliveryDate = trackingInfo.ActualDeliveryDate || trackingInfo.RecipientDateTime || trackingInfo.DateCreated;
    events.push({
      title: 'Received',
      description: `Received on ${formatDate(deliveryDate)}`,
      completed: true,
      received: true
    });
  } 
  // ЕСЛИ DELIVERED - оранжевый кружок
  else if (isDelivered) {
    const deliveryDate = trackingInfo.ActualDeliveryDate || trackingInfo.DateCreated;
    events.push({
      title: 'Delivered',
      description: `Delivered on ${formatDate(deliveryDate)}`,
      completed: true,
      delivered: true
    });
  } 
  // ЕСЛИ НЕ ДОСТАВЛЕНО - Estimated Delivery
  else if (trackingInfo.ScheduledDeliveryDate) {
    events.push({
      title: 'Estimated Delivery',
      description: `Expected by ${formatDate(trackingInfo.ScheduledDeliveryDate)}`,
      completed: false,
      active: false
    });
  }

  return events.map(event => `
    <div class="timeline-item ${event.active ? 'active' : ''} ${event.completed ? 'completed' : ''} ${event.received ? 'received' : ''} ${event.delivered ? 'delivered' : ''}">
      <div class="timeline-dot"></div>
      <div class="timeline-content">
        <h3>${event.title}</h3>
        <p>${event.description}</p>
      </div>
    </div>
  `).join('');
}

  function formatDate(dateString) {
    if (!dateString) return '';
    
    let date;
    
    if (dateString.includes('-') && dateString.split('-')[0].length === 2) {
      const parts = dateString.split(' ')[0].split('-');
      date = new Date(parts[2], parts[1] - 1, parts[0]);
    } else {
      date = new Date(dateString);
    }
    
    if (isNaN(date.getTime())) return dateString;
    
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  }

  function showPreparing(orderNumber, trackingNumber = null) {
    const html = `
      <div class="result-empty">
        <div class="result-icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="9" y1="9" x2="15" y2="9"></line>
            <line x1="9" y1="15" x2="15" y2="15"></line>
          </svg>
        </div>
        <h3>Preparing Your Order</h3>
        <p>Order ${orderNumber} is being prepared for shipment.<br>${trackingNumber ? `Tracking: ${trackingNumber}<br>` : ''}Tracking information will be available soon.</p>
      </div>
    `;
    
    resultsContainer.innerHTML = html;
    resultsContainer.classList.add('show');
    
    setTimeout(() => {
      resultsContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 100);
  }

  function showError(title, message) {
    const html = `
      <div class="result-error">
        <div class="result-icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
        </div>
        <h3>${title}</h3>
        <p>${message}</p>
      </div>
    `;
    
    resultsContainer.innerHTML = html;
    resultsContainer.classList.add('show');
    
    setTimeout(() => {
      resultsContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 100);
  }

  function setLoadingState(button, isLoading) {
    if (isLoading) {
      button.classList.add('loading');
      button.disabled = true;
    } else {
      button.classList.remove('loading');
      button.disabled = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();